import DialogContent from "@mui/material/DialogContent";
import {displayAttributeWithMod} from "../../_helper/displayAttributeWithMod";
import FormControl from "@mui/material/FormControl";
import {Checkbox, FormLabel} from "@mui/material";
import {s_char, s_char_lp_changes} from "../../_signals/s_char";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";
import charcreate from "../../_helper/charcreate";
import ccAttribute from "../../_helper/ccAttribute";
import {setBase} from "../../_signals/s_char_calc";
import {s_char_attr_sum} from "../../_signals/s_char_attr";
import {attributeRaiseChanges} from "../../_helper/attributeRaiseChanges";
import CharCreate from "../../_helper/charcreate";
import {v4} from "uuid";
import updChar from "../../_sig_api/updChar";
import {CharacterFieldUpdateField} from "../../_payload/CharacterFieldUpdateField";
import {ICharLPChanges} from "../../_interfaces/ICharLPChanges";
import {LPChangesCreate} from "../../_api/BELPChanges";
import {s_app_sl} from "../../_signals/s_app";

type Props = {
    attribute: string,
    open: boolean,
    setOpen: (arg0: boolean) => void
}
export default function AttributeRaise({attribute, open, setOpen}: Props) {

    const [attrKarma, setAttrKarma] = useState(false);

    useEffect(() => {
        const k = s_char.value[attribute + '_k']==1
        setAttrKarma(k);
    }, [attribute]);

    const handleKarmaChange = (checked: boolean) => {
        setAttrKarma(checked);
        updChar([{k: attribute + '_k', v: checked}])
    }

    const handleRaiseValue = () => {

        const sl = s_app_sl.value
        let lp_current = s_char.value.lp_current;
        const nsc = s_char.value.nsc;

        const no_lp = nsc && sl;

        if (nsc && !sl) return;

        const nextValue = parseInt(s_char.value[attribute + '_r']) + 1;

        const cost = charcreate.raiseCost(500, nextValue) // eine schwierigkeit weniger

        if (no_lp) {
            raise(0);
        } else if (cost > 0) {
            if (cost < lp_current) {
                if (window.confirm('Steigerung ' + ccAttribute(attribute, 'title') + ' Kosten ' + cost)) {
                    raise(cost);
                }
            } else alert('zu wenig lp');
        } else alert('lp kosten fehler');
    }

    const raise = (cost: number) => {
        const field = attribute + '_r';
        const raise = parseInt(s_char.value[field]) + 1;
        let upd: CharacterFieldUpdateField[] = [{k: field, v: raise}]
        setBase();

        if (cost > 0) {
            const new_lp_current = s_char.value.lp_current - cost;
            upd.push({k: 'lp_current', v: new_lp_current})

            const ts = new Date().toISOString().slice(0, 19).replace('T', ' ');
            const newchange: ICharLPChanges = {
                id: v4(),
                cid: s_char.value.id,
                ts: ts,
                entry: '-' + cost + ' Steigerung Attribut ' + attribute
            }
            s_char_lp_changes.value = [...s_char_lp_changes.value, newchange];

            LPChangesCreate(newchange);

        }
        updChar(upd)
    }

    let attr_sum = s_char_attr_sum(attribute).value;

    const diffs = attributeRaiseChanges(attribute, attr_sum, attr_sum + 5 - s_char.value[attribute + '_r']);

    const ccattr = CharCreate.attributes.filter(e => e.pfield === attribute).shift();
    const title = ccattr!.tt;

    const raiseCost = CharCreate.attribute_raise_cost.find(rc =>
        rc.r === (parseInt(s_char.value[attribute + '_r']) + 1)
    );

    return <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogContent>
            <div>Attribut: {title}</div>
            <div>Wert: {attr_sum} Stufe: {displayAttributeWithMod(attribute)}</div>

            <FormControl>
                <FormLabel>Karma möglich?</FormLabel>
                <Checkbox
                    defaultChecked={attrKarma}
                    onChange={(e) => handleKarmaChange(e.target.checked)}
                />
            </FormControl>
            <div>Steigerungen: {s_char.value[attribute + '_r']}</div>
            {s_char.value[attribute + '_r'] < 5 ? <div>
                <Button variant="outlined"
                        onClick={() => handleRaiseValue()}>
                    steigern
                </Button>
                <span> LP-Kosten: {raiseCost ? raiseCost.c : '-'}</span>
                {diffs.length > 0 ? <div>
                    Änderungen:
                    {diffs.map((d) => <div key={v4()}>Wert: {d.v} -&gt; {d.c.join(', ')}</div>)}
                </div> : null}
            </div> : null}
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpen(false)}><ClearIcon/></Button>
        </DialogActions>
    </Dialog>
}